export default {
	'en': {
		name: 'English (US)',
		load: () => { return import('./en.json'); },
	},
	'pt': {
		name: 'Português (BR)',
		load: () => { return import('./pt.json'); },
	},
	'es-PE': {
		name: 'Español',
		load: () => { return import('./es.json'); },
	},
};
